module.exports = __webpack_public_path__ + "img/main_architecture_image01_en.dd52f03f.jpg";